(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["APRIS-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apris-reviews')) {
    customElements.define('apris-reviews', class extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && window.Shopify.designMode && this.querySelector('.apris-reviews__viewport')) this.initialize();
        else this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.viewport = this.querySelector('.apris-reviews__viewport');
        this.controls = this.querySelector('.apris-reviews__controls');
        if (!this.viewport || !this.controls) return;
        this.fill = this.controls.querySelector('.apris-reviews__progress span');
        this.previous = this.querySelector('[data-apris-prev]');
        this.next = this.querySelector('[data-apris-next]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.update = () => {
          const total = this.viewport.scrollWidth;
          const visible = this.viewport.clientWidth;
          const remaining = Math.max(0, total - visible);
          const position = Math.max(0, Math.min(remaining, this.viewport.scrollLeft));
          this.controls.hidden = remaining <= 2;
          if (this.fill) this.fill.style.transform = `scaleX(${total ? Math.min(1, (visible + position) / total) : 1})`;
          if (this.previous) this.previous.disabled = position <= 2;
          if (this.next) this.next.disabled = position >= remaining - 2;
        };
        this.move = (direction) => {
          const items = this.querySelectorAll('[data-apris-review]');
          if (!items.length) return;
          const step = items.length > 1 ? items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left : items[0].getBoundingClientRect().width;
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.viewport.scrollBy({ left: direction * step, behavior });
        };
        this.viewport.addEventListener('scroll', this.update, { ...options, passive: true });
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = event.target.closest('[data-apris-review]');
          if (!selected) return;
          const left = this.viewport.scrollLeft + selected.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.viewport.scrollTo({ left, behavior: 'auto' });
        }, options);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.viewport);
        this.classList.add('is-enhanced');
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Apris-Step"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apris-steps')) {
    customElements.define('apris-steps', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.viewport = this.querySelector('.apris-steps__viewport');
        this.progress = this.querySelector('.apris-steps__progress');
        if (!this.viewport || !this.progress) return;
        this.fill = this.progress.querySelector('span');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.update = () => {
          const total = this.viewport.scrollWidth;
          const visible = this.viewport.clientWidth;
          const remaining = Math.max(0, total - visible);
          const position = Math.max(0, Math.min(remaining, this.viewport.scrollLeft));
          this.progress.hidden = remaining <= 2;
          this.fill.style.transform = `scaleX(${total ? Math.min(1, (visible + position) / total) : 1})`;
        };
        this.viewport.addEventListener('scroll', this.update, { ...options, passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const selected = event.target.closest('[data-apris-step]');
          if (!selected) return;
          const left = this.viewport.scrollLeft + selected.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.viewport.scrollTo({ left, behavior: 'auto' });
        }, options);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.viewport);
        this.classList.add('is-enhanced');
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Apris-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('apris-benefits')) return;
    customElements.define('apris-benefits', class extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && window.Shopify.designMode && this.querySelector('.apris-benefits__viewport')) this.initialize();
        else this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.events) return;
        this.viewport = this.querySelector('.apris-benefits__viewport');
        this.controls = this.querySelector('.apris-benefits__controls');
        if (!this.viewport || !this.controls) return;
        this.fill = this.controls.querySelector('.apris-benefits__progress span');
        this.previous = this.querySelector('[data-abn-prev]');
        this.next = this.querySelector('[data-abn-next]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.update = () => {
          const total = this.viewport.scrollWidth;
          const visible = this.viewport.clientWidth;
          const remaining = Math.max(0, total - visible);
          const position = Math.max(0, Math.min(remaining, this.viewport.scrollLeft));
          const fits = remaining <= 2;
          this.controls.hidden = fits;
          if (fits) this.viewport.removeAttribute('tabindex');
          else this.viewport.setAttribute('tabindex', '0');
          if (this.fill) this.fill.style.transform = 'scaleX(' + (total ? Math.min(1, (visible + position) / total) : 1) + ')';
          if (this.previous) this.previous.disabled = position <= 2;
          if (this.next) this.next.disabled = position >= remaining - 2;
        };
        this.move = (direction) => {
          const items = this.querySelectorAll('[data-abn-item]');
          if (!items.length) return;
          const step = items.length > 1 ? items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left : items[0].getBoundingClientRect().width;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.viewport.scrollBy({ left: direction * step, behavior: behavior });
        };
        this.viewport.addEventListener('scroll', this.update, { signal: this.events.signal, passive: true });
        if (this.previous) this.previous.addEventListener('click', () => this.move(-1), options);
        if (this.next) this.next.addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = event.target.closest('[data-abn-item]');
          if (!selected) return;
          const left = this.viewport.scrollLeft + selected.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.viewport.scrollTo({ left: left, behavior: 'auto' });
        }, options);
        window.addEventListener('resize', this.update, { signal: this.events.signal, passive: true });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.viewport);
        }
        this.classList.add('is-enhanced');
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        if (this.observer) this.observer.disconnect();
        this.events = null;
        this.observer = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Apris-comparaison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('apris-comparison')) return;
    customElements.define('apris-comparison', class extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && window.Shopify.designMode && this.querySelector('.apris-comparison__viewport')) this.initialize();
        else this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.events) return;
        this.viewport = this.querySelector('.apris-comparison__viewport');
        this.controls = this.querySelector('.apris-comparison__controls');
        if (!this.viewport || !this.controls) return;
        this.fill = this.controls.querySelector('.apris-comparison__progress span');
        this.previous = this.querySelector('[data-acp-prev]');
        this.next = this.querySelector('[data-acp-next]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.update = () => {
          const total = this.viewport.scrollWidth;
          const visible = this.viewport.clientWidth;
          const remaining = Math.max(0, total - visible);
          const position = Math.max(0, Math.min(remaining, this.viewport.scrollLeft));
          const fits = remaining <= 2;
          this.controls.hidden = fits;
          if (fits) this.viewport.removeAttribute('tabindex');
          else this.viewport.setAttribute('tabindex', '0');
          if (this.fill) this.fill.style.transform = 'scaleX(' + (total ? Math.min(1, (visible + position) / total) : 1) + ')';
          if (this.previous) this.previous.disabled = position <= 2;
          if (this.next) this.next.disabled = position >= remaining - 2;
        };
        this.move = (direction) => {
          const column = this.querySelector('.apris-comparison__band');
          const step = column ? column.getBoundingClientRect().width : this.viewport.clientWidth / 2;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.viewport.scrollBy({ left: direction * step, behavior: behavior });
        };
        this.viewport.addEventListener('scroll', this.update, { signal: this.events.signal, passive: true });
        if (this.previous) this.previous.addEventListener('click', () => this.move(-1), options);
        if (this.next) this.next.addEventListener('click', () => this.move(1), options);
        window.addEventListener('resize', this.update, { signal: this.events.signal, passive: true });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.viewport);
        }
        this.classList.add('is-enhanced');
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        if (this.observer) this.observer.disconnect();
        this.events = null;
        this.observer = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Apris-materials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('apris-material')) return;
    customElements.define('apris-material', class extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && window.Shopify.designMode && this.querySelector('details.apris-material__row')) this.initialize();
        else this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.events) return;
        this.rows = Array.from(this.querySelectorAll('details.apris-material__row'));
        if (!this.rows.length) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.single = this.hasAttribute('data-single');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.running = new Map();
        this.rows.forEach((row) => {
          const trigger = row.querySelector('.apris-material__trigger');
          if (!trigger) return;
          row.removeAttribute('name');
          row.classList.toggle('is-open', row.open);
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            this.setRow(row, !row.classList.contains('is-open'), false);
          }, options);
          row.addEventListener('toggle', () => {
            if (this.running.has(row)) return;
            if (row.open === row.classList.contains('is-open')) return;
            this.setRow(row, row.open, true);
          }, options);
        });
        this.addEventListener('shopify:block:select', (event) => {
          const row = event.target.closest('details.apris-material__row');
          if (row && this.contains(row)) this.setRow(row, true, true);
        }, options);
        this.classList.add('is-enhanced');
      }
      setRow(row, open, instant) {
        if (open && this.single) {
          this.rows.forEach((other) => {
            if (other !== row && other.classList.contains('is-open')) this.setRow(other, false, instant);
          });
        }
        const panel = row.querySelector('.apris-material__panel');
        const previous = this.running.get(row);
        const from = panel && row.open ? panel.getBoundingClientRect().height : 0;
        if (previous) {
          this.running.delete(row);
          previous.cancel();
        }
        row.classList.toggle('is-open', open);
        if (open) row.open = true;
        if (!panel || instant || this.motion.matches || typeof panel.animate !== 'function') {
          row.open = open;
          return;
        }
        const to = open ? panel.scrollHeight : 0;
        const animation = panel.animate(
          { height: [from + 'px', to + 'px'] },
          { duration: 400, easing: 'ease', fill: 'forwards' }
        );
        this.running.set(row, animation);
        animation.onfinish = () => {
          if (this.running.get(row) !== animation) return;
          this.running.delete(row);
          if (!open) row.open = false;
          animation.cancel();
        };
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        if (this.running) {
          this.running.forEach((animation) => animation.cancel());
          this.running.clear();
        }
        this.events = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Apris-relief"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('apris-contour-hold')) return;
    customElements.define('apris-contour-hold', class extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && window.Shopify.designMode && this.querySelector('.apris-contour-hold__viewport')) this.initialize();
        else this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.events) return;
        this.viewport = this.querySelector('.apris-contour-hold__viewport');
        this.progress = this.querySelector('.apris-contour-hold__progress');
        if (!this.viewport || !this.progress) return;
        this.fill = this.progress.querySelector('span');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.update = () => {
          const total = this.viewport.scrollWidth;
          const visible = this.viewport.clientWidth;
          const remaining = Math.max(0, total - visible);
          const position = Math.max(0, Math.min(remaining, this.viewport.scrollLeft));
          const fits = remaining <= 2;
          this.progress.hidden = fits;
          if (fits) this.viewport.removeAttribute('tabindex');
          else this.viewport.setAttribute('tabindex', '0');
          if (this.fill) this.fill.style.transform = 'scaleX(' + (total ? Math.min(1, (visible + position) / total) : 1) + ')';
        };
        this.viewport.addEventListener('scroll', this.update, { signal: this.events.signal, passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const selected = event.target.closest('[data-apris-item]');
          if (!selected) return;
          const left = this.viewport.scrollLeft + selected.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.viewport.scrollTo({ left: left, behavior: 'auto' });
        }, options);
        window.addEventListener('resize', this.update, { signal: this.events.signal, passive: true });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.viewport);
        }
        this.classList.add('is-enhanced');
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        if (this.observer) this.observer.disconnect();
        this.events = null;
        this.observer = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Apris-signs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('apris-knee-signs')) return;
    customElements.define('apris-knee-signs', class extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && window.Shopify.designMode && this.querySelector('.apris-knee-signs__viewport')) this.initialize();
        else this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.events) return;
        this.viewport = this.querySelector('.apris-knee-signs__viewport');
        this.controls = this.querySelector('.apris-knee-signs__controls');
        if (!this.viewport || !this.controls) return;
        this.fill = this.controls.querySelector('.apris-knee-signs__progress span');
        this.previous = this.querySelector('[data-aks-prev]');
        this.next = this.querySelector('[data-aks-next]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.update = () => {
          const total = this.viewport.scrollWidth;
          const visible = this.viewport.clientWidth;
          const remaining = Math.max(0, total - visible);
          const position = Math.max(0, Math.min(remaining, this.viewport.scrollLeft));
          const fits = remaining <= 2;
          this.controls.hidden = fits;
          if (fits) this.viewport.removeAttribute('tabindex');
          else this.viewport.setAttribute('tabindex', '0');
          if (this.fill) this.fill.style.transform = 'scaleX(' + (total ? Math.min(1, (visible + position) / total) : 1) + ')';
          if (this.previous) this.previous.disabled = position <= 2;
          if (this.next) this.next.disabled = position >= remaining - 2;
        };
        this.move = (direction) => {
          const items = this.querySelectorAll('[data-aks-item]');
          if (!items.length) return;
          const step = items.length > 1 ? items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left : items[0].getBoundingClientRect().width;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.viewport.scrollBy({ left: direction * step, behavior: behavior });
        };
        this.viewport.addEventListener('scroll', this.update, { signal: this.events.signal, passive: true });
        if (this.previous) this.previous.addEventListener('click', () => this.move(-1), options);
        if (this.next) this.next.addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = event.target.closest('[data-aks-item]');
          if (!selected) return;
          const left = this.viewport.scrollLeft + selected.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.viewport.scrollTo({ left: left, behavior: 'auto' });
        }, options);
        window.addEventListener('resize', this.update, { signal: this.events.signal, passive: true });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.viewport);
        }
        this.classList.add('is-enhanced');
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        if (this.observer) this.observer.disconnect();
        this.events = null;
        this.observer = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Apris-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('apris-relief-timeline')) return;
    const remembered = {};
    customElements.define('apris-relief-timeline', class extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && window.Shopify.designMode && this.querySelector('[data-atl-panel]')) this.initialize();
        else this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.events) return;
        this.panels = Array.from(this.querySelectorAll('[data-atl-panel]'));
        if (!this.panels.length) return;
        this.list = this.querySelector('.apris-relief-timeline__tabs');
        this.tabs = Array.from(this.querySelectorAll('[data-atl-tab]'));
        if (!this.list || this.tabs.length !== this.panels.length) this.tabs = [];
        this.columns = Number(this.getAttribute('data-columns')) || 2;
        const holder = this.closest('.shopify-section');
        this.key = window.Shopify && window.Shopify.designMode && holder ? holder.id : '';
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        if (this.tabs.length) {
          this.list.setAttribute('role', 'tablist');
          this.tabs.forEach((tab, index) => {
            const panel = this.panels[index];
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', panel.id);
            tab.parentElement.setAttribute('role', 'presentation');
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tab.id);
            panel.tabIndex = 0;
          });
          this.list.addEventListener('click', (event) => {
            const tab = event.target.closest('[data-atl-tab]');
            if (!tab) return;
            event.preventDefault();
            this.activate(this.tabs.indexOf(tab), true);
          }, options);
          this.list.addEventListener('keydown', (event) => {
            const tab = event.target.closest('[data-atl-tab]');
            if (!tab) return;
            const count = this.tabs.length;
            const index = this.tabs.indexOf(tab);
            const row = count > this.columns ? this.columns : 1;
            const moves = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: row, ArrowUp: -row };
            let next;
            if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = count - 1;
            else if (event.key === ' ' || event.key === 'Spacebar') next = index;
            else if (Object.prototype.hasOwnProperty.call(moves, event.key)) next = (index + moves[event.key] + count) % count;
            else return;
            event.preventDefault();
            this.activate(next, true, true);
          }, options);
        }
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.indexOf(event.target.closest('[data-atl-panel]'));
          if (index >= 0) this.activate(index, false);
        }, options);
        let start = Math.max(0, this.panels.findIndex((panel) => panel.classList.contains('is-active')));
        if (this.key && remembered[this.key] !== undefined) start = remembered[this.key];
        this.activate(start, false);
        this.classList.add('is-enhanced');
      }
      activate(index, animate, focus) {
        const next = Math.max(0, Math.min(index, this.panels.length - 1));
        if (next !== this.current) this.classList.toggle('is-animated', Boolean(animate) && this.current !== undefined);
        this.current = next;
        if (this.key) remembered[this.key] = next;
        this.panels.forEach((panel, position) => panel.classList.toggle('is-active', position === next));
        this.tabs.forEach((tab, position) => {
          const selected = position === next;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        if (focus && this.tabs[next]) this.tabs[next].focus();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        this.events = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
